import {GetCarPassRequestResponseBody} from '@dms/api/vehicle';

export const CarPassState = {
  NONE: 'NONE',
  PENDING: 'PENDING',
  WAITING_FOR_DIV: 'WAITING_FOR_DIV',
  ACTION_REQUIRED: 'ACTION_REQUIRED',
  ACTION_TAKEN: 'ACTION_TAKEN',
  READY: 'READY',
  EXPIRED: 'EXPIRED',
  FAILED: 'FAILED',
} as const;

export type CarPassState = (typeof CarPassState)[keyof typeof CarPassState];

export const deriveCarPassState = (request: GetCarPassRequestResponseBody | undefined) =>
  request?.state ?? CarPassState.NONE;
